import React, { Component } from 'react';

import { Card, Collapse } from 'react-bootstrap'

export default class Faq extends Component {

	constructor(props) {
		super(props);
		this.state = {
			open: false,
		};
		this.handleKeyUp = this.handleKeyUp.bind(this);
	}

	handleKeyUp(event) {
		if (event.keyCode === 13) {
			event.preventDefault();
			event.currentTarget.click();
		}
	}

	render() {
		return (
			<Card>
				<Card.Header tabIndex="0" role="button" onClick={() => this.setState({ open: !this.state.open })} style={{ cursor: "pointer" }} onKeyUp={this.handleKeyUp}>
					{this.props.question}
				</Card.Header>
				<Collapse in={this.state.open}>
					<div>
						<Card.Body style={{ "textAlign": "left" }}>
							{this.props.answer}
						</Card.Body>
					</div>
				</Collapse>
			</Card>
		);
	}
}